const ICU = require('i18next-icu/dist/commonjs').default;
const HttpBackend = require('i18next-http-backend/cjs');
const ChainedBackend = require('i18next-chained-backend').default;
const languageMap = require('./public/locales/i18n/forumsTranslationManifest.json');

module.exports = {
  backend: {
    backendOptions: [{
      loadPath: (localeList) => languageMap[localeList[0]] || languageMap['en-US'],
    }],
    backends: typeof window !== 'undefined' ? [HttpBackend] : [],
  },
  i18n: {
    defaultLocale: 'en-US',
    locales: ['en-US'],
  },
  use: typeof window !== 'undefined' ? [ChainedBackend, ICU] : [ICU],
  serializeConfig: false,
  partialBundledLanguages: true,
  defaultNS: 'common',
};
